module.exports = __webpack_public_path__ + "29b478b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/desktop/components/AdvertPhotos/car.svg
// module id = 2769
// module chunks = 32 36